import { Scale } from 'lucide-react';

export const HumanRightsIcon = ({
  size = 24,
  color = 'currentColor',
  ...props
}) => {
  return (
    // <svg
    //   width="26"
    //   height="26"
    //   viewBox="0 0 26 26"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M5.55208 6.68408C8.43702 6.68408 11.0586 5.37856 13 3.25C14.9414 5.37856 17.563 6.68408 20.4479 6.68408C20.4938 6.68408 20.5395 6.68375 20.5852 6.68309C20.9355 7.91647 21.125 9.23432 21.125 10.6034C21.125 16.4473 17.6725 21.3577 13 22.75C8.32751 21.3577 4.875 16.4473 4.875 10.6034C4.875 9.23432 5.06449 7.91647 5.41477 6.68309C5.46047 6.68375 5.50624 6.68408 5.55208 6.68408Z"
    //     stroke="var(--color-people-blue)"
    //     strokeWidth="1.25"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    // </svg>
    <Scale size={size} stroke={color} strokeWidth={1.5} {...props} />
  );
};

export default HumanRightsIcon;